<template>
    <div class="container pt-10 newsevents-wrapper">
        <three-sections-layout>
            <template v-slot:top-section>
                <div class="search mt-5 mt-md-0">
                    <tabs-list :data="tabData" :maxWidth="700" @onTabChange="onTabChange"></tabs-list>
                </div>
            </template>
            <template v-slot:left-content>
                <news-bulletins :PrimaryFilter="Filter" />
            </template>
            <template v-slot:right-content>
                <events-list :PrimaryFilter="Filter"></events-list>
            </template>
        </three-sections-layout>
    </div>
</template>
<script>
    import NewsBulletins from "../../components/molecules/NewsBulletins.vue";
    import EventsList from "../../components/molecules/EventsList.vue";
    import ThreeSectionsLayout from "../../components/molecules/ThreeSectionsLayout.vue";
    import TabsList from '../../components/atoms/TabsList.vue';
    export default {
        name: "NewsEvents",
        components: {
            NewsBulletins,
            ThreeSectionsLayout,
            EventsList,
            TabsList
        },
        data() {
            return {
                    tabData:[
                        {   "key":sessionStorage.getItem('brand'),
                            "value":sessionStorage.getItem('brand'),
                            "type":"brand"
                        },
                        {   "key":window.DEALER_LOCATION.dealerLocationID,
                            "value":window.DEALER_LOCATION.name ,
                            "type":"dealer"
                        }
                    ],
                    Data:{}
            };
        },
        methods: {
            onTabChange(e)
            {
                this.Data=e.eventData;
            }
        },
        computed:{
            Filter(){
                return this.Data
            }
        },
        mounted() {
            this.Data=this.tabData[0];
        }
    };
</script>